import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/marketing/misc/squiggly_arrow.png")